import cn from "classnames";
import { Field } from "components/shared/form";
import React, { useState } from "react";
import { apply, delItem } from "sources/books/admin/unstableZones";
import PolygonPicker from "./polygonPicker";

export default function UnstableZonesForm(props) {
    const [data, setData] = useState(props.data || { name: "", coordinates: [] });
    const [isLooped, setIsLooped] = useState(!!props.data);
    const [loading, setLoading] = useState(false);
    const handleSubmit = () => {
        if (!isLooped || !data.name.length) {
            return;
        }
        setLoading(true);
        const inverted = data.coordinates.map((item) => [...item].reverse());
        apply({ ...data, coordinates: inverted }).then((res) => {
            if (res) {
                props.mergeParams();
                props.back();
            }
            setLoading(false);
        });
    };

    const handleDelete = () => {
        setLoading(true);
        delItem({ id: props.data.id }).then((res) => {
            if (res) {
                props.mergeParams();
                props.back();
            }
            setLoading(false);
        });
    };

    const setPoints = (points) => setData({ ...data, coordinates: points });

    return (
        <div className={loading ? "loading" : ""}>
            <Field
                label="Название"
                inputProps={{ name: "name" }}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.name}
            />
            <div className="pb-2" style={{ height: "45vh" }}>
                <PolygonPicker
                    points={data.coordinates}
                    setPoints={setPoints}
                    isLooped={isLooped}
                    setIsLooped={setIsLooped}
                />
            </div>
            <div className="d-flex justify-content-between">
                {props.data?.id ? (
                    <div className="btn btn-sm btn-danger" onClick={handleDelete}>
                        Удалить
                    </div>
                ) : (
                    <div />
                )}
                <div
                    className={cn("btn btn-sm btn-brand", { disabled: !isLooped || !data.name.length })}
                    onClick={handleSubmit}
                >
                    Сохранить
                </div>
            </div>
        </div>
    );
}
